import {t} from "i18next";
import {Link} from "react-router-dom";
import {useLogout} from "../../../lib/utils/hooks/useLogout";

const AccountActionsProfile = () => {
    const goOut = useLogout()
    return (
        <>
            <h1 className='profile-title'>{t('profile.navigationMenu.routes.accountActions')}</h1>
            <Link to="/logout/" className="form-button small-button btn btn-green" onClick={goOut}>
                {t('profile.accountActions.leave')}
            </Link>
        </>
    )
}

export default AccountActionsProfile;